import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { database } from "../../appWrite"; // Import your Appwrite instance

const databaseId = "67ce8a4a0032e13c6368"; // Replace with your Appwrite database ID
const collectionId = "67d139a9000478a4ce8f"; // Replace with your Appwrite collection ID

// Async thunk to fetch blog posts
export const fetchPosts = createAsyncThunk(
  "posts/fetchPosts",
  async (_, { rejectWithValue }) => {
    try {
      const response = await database.listDocuments(databaseId, collectionId);
      return response.documents; // Return fetched posts
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to fetch posts");
    }
  }
);

// Initial state
interface PostState {
  posts: any[];
  loading: boolean;
  error: string | null;
}

const initialState: PostState = {
  posts: [],
  loading: false,
  error: null,
};

// Redux slice
const postSlice = createSlice({
  name: "posts",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPosts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPosts.fulfilled, (state, action) => {
        state.loading = false;
        state.posts = action.payload;
      })
      .addCase(fetchPosts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default postSlice.reducer;
